var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMastercardIcon = function SvgMastercardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 2.25,
    fill: "#fff",
    stroke: "#DFDFDF",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.986 11.755a5.056 5.056 0 0 1-3.26 1.18c-2.776 0-5.026-2.212-5.026-4.942S5.95 3.05 8.726 3.05c1.244 0 2.382.444 3.26 1.18a5.056 5.056 0 0 1 3.26-1.18c2.775 0 5.025 2.213 5.025 4.943 0 2.73-2.25 4.943-5.025 4.943a5.055 5.055 0 0 1-3.26-1.181Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.986 11.755a4.899 4.899 0 0 0 1.765-3.762 4.9 4.9 0 0 0-1.765-3.762 5.056 5.056 0 0 1 3.26-1.181c2.775 0 5.025 2.213 5.025 4.943 0 2.73-2.25 4.943-5.025 4.943a5.056 5.056 0 0 1-3.26-1.181Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.986 11.755a4.9 4.9 0 0 0 1.765-3.762 4.9 4.9 0 0 0-1.765-3.762 4.9 4.9 0 0 0-1.766 3.762 4.9 4.9 0 0 0 1.766 3.762Z",
    fill: "#FF5E00"
  })));
};

export default SvgMastercardIcon;